import { render, staticRenderFns } from "./SimulationBanner.vue?vue&type=template&id=38ac7e0e&scoped=true&"
import script from "./SimulationBanner.vue?vue&type=script&lang=js&"
export * from "./SimulationBanner.vue?vue&type=script&lang=js&"
import style0 from "./SimulationBanner.vue?vue&type=style&index=0&id=38ac7e0e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac7e0e",
  null
  
)

export default component.exports